'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _activator = require('hellosign/common/zendesk/components/activator');

var _activator2 = _interopRequireDefault(_activator);

var _blocks = require('ui/blocks');

var _tetherToggle = require('ui/tether-toggle');

var _tetherToggle2 = _interopRequireDefault(_tetherToggle);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MenuLink = function MenuLink(props) {
    return _react2['default'].createElement(_blocks.Box, _extends({
        className: 'm-app-footer--menu-item',
        color: 'grey',
        hoverColor: 'ashen',
        is: 'a',
        display: 'block',
        textAlign: 'left',
        px: 3,
        py: 2
    }, props));
};

function HelpLink(_ref) {
    var onActivate = _ref.onActivate;

    return _react2['default'].createElement(
        _blocks.Box,
        { p: 3, className: 'm-app-footer--links--link', onClick: onActivate },
        _react2['default'].createElement(
            _blocks.Box,
            { is: 'a', href: 'javascript:;', id: 'footer_help', color: 'grey', hoverColor: 'ashen' },
            'Help'
        )
    );
}

var ZendeskActivator = (0, _activator2['default'])(HelpLink);

// In-app footer
var AppFooter = _react2['default'].createClass({
    displayName: 'AppFooter',

    propTypes: {
        'siteCode': _react2['default'].PropTypes.string.isRequired // S or F
    },

    SOCIAL_NAMES: ['linkedin', 'fb', 'twitter'],
    SOCIAL_URLS: {
        'twitter': 'https://twitter.com/hellosign',
        'fb': 'https://www.facebook.com/hellosignapp',
        'linkedin': 'https://www.linkedin.com/company/hellosign'
    },

    getInitialState: function getInitialState() {
        return {
            'showProductMenu': false,
            'showFinePrintMenu': false
        };
    },
    componentDidMount: function componentDidMount() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.product-link', root).hover(this.toggleProductMenu);
        $('.fine-print-link', root).hover(this.toggleFinePrintMenu);
    },
    toggleProductMenu: function toggleProductMenu() {
        var show = !this.state.showProductMenu;
        this.setState({
            'showProductMenu': show
        });
    },
    toggleFinePrintMenu: function toggleFinePrintMenu() {
        var show = !this.state.showFinePrintMenu;
        this.setState({
            'showFinePrintMenu': show
        });
    },
    render: function render() {
        var _props = this.props,
            className = _props.className,
            responsive = _props.responsive;

        var cmsSubDomain = 'www';
        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var pricingUrl = _hfReactHelper2['default'].urlHelper('info/pricing', site);
        var homeUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var faqUrl = isHf ? 'http://faq.hellosign.com/hc/en-us/categories/200353237-HelloFax-Help' : 'http://faq.hellosign.com';
        var hfHomeUrl = _hfReactHelper2['default'].urlHelper('home/bridge/to/F', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
        var hsHomeUrl = _hfReactHelper2['default'].urlHelper('home/bridge/to/S', _hfReactHelper2['default'].HfSites.SITE_CODE_HF);
        var bridgeUrl = isHf ? hsHomeUrl : hfHomeUrl;

        var socialImageUrls = {
            twitter: require('./twitter@2x.png'),
            fb: require('./fb@2x.png'),
            linkedin: require('./linkedin@2x.png')
        };

        // Social links
        var name;
        var social = [];
        for (var i in this.SOCIAL_NAMES) {
            name = this.SOCIAL_NAMES[i];
            social.push(_react2['default'].createElement(
                _blocks.Box,
                { px: [3, 0], py: 3, ml: [0, 1], key: 'social-' + i, className: 'm-app-footer--social--icon' },
                _react2['default'].createElement(
                    _blocks.Box,
                    { is: 'a', href: this.SOCIAL_URLS[name], target: '_blank', rel: 'noopener noreferrer', display: 'block' },
                    _react2['default'].createElement(_blocks.Box, { is: 'img', verticalAlign: 'middle', className: 'm-app-footer--social--icon--img', src: socialImageUrls[name] })
                )
            ));
        }

        // Product menu
        var items = [isHf ? undefined : _react2['default'].createElement(
            MenuLink,
            { key: 0, href: _hfReactHelper2['default'].urlHelper('api', site, cmsSubDomain) },
            'API'
        ), isHf ? undefined : _react2['default'].createElement(
            MenuLink,
            { key: 1, href: _hfReactHelper2['default'].urlHelper('gmail', site, cmsSubDomain) },
            'Gmail'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 2, href: _hfReactHelper2['default'].urlHelper('googledocs', site, cmsSubDomain) },
            'Google Docs'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 3, href: _hfReactHelper2['default'].urlHelper('googledrive', site, cmsSubDomain) },
            'Google Drive'
        ), isHf ? undefined : _react2['default'].createElement(
            MenuLink,
            { key: 4, href: _hfReactHelper2['default'].urlHelper('info/mobile', site, cmsSubDomain) },
            'Mobile'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 5, href: bridgeUrl, target: '_blank', rel: 'noopener noreferrer' },
            'Hello' + (isHf ? 'Sign' : 'Fax')
        )];

        // Fine print menu
        var finePrintItems = [_react2['default'].createElement(
            MenuLink,
            { key: 0, href: _hfReactHelper2['default'].urlHelper('info/security', site, cmsSubDomain) },
            'Security'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 1, href: _hfReactHelper2['default'].urlHelper('info/legal', site, cmsSubDomain) },
            'Legal'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 2, href: _hfReactHelper2['default'].urlHelper('info/privacyPolicy', site, cmsSubDomain) },
            'Privacy'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 3, href: _hfReactHelper2['default'].urlHelper('info/tos', site, cmsSubDomain) },
            'Terms'
        )];

        return _react2['default'].createElement(
            _blocks.Flex,
            {
                className: className,
                flexDirection: responsive ? ['column', 'row'] : 'row',
                justifyContent: responsive ? [null, 'space-between'] : 'space-between',
                borderTop: 1,
                marginBottom: 3,
                borderColor: 'warm-chinchilla' },
            _react2['default'].createElement(
                _blocks.Flex,
                {
                    textAlign: responsive ? ['center', 'left'] : 'center',
                    flexDirection: responsive ? ['column', 'row'] : 'row',
                    alignItems: 'center' },
                _react2['default'].createElement(
                    _blocks.Box,
                    {
                        px: responsive ? [3, 0] : 0,
                        py: responsive ? [3, 0] : 0,
                        className: 'm-app-footer--logo' },
                    _react2['default'].createElement(
                        _blocks.Box,
                        { is: 'a', href: homeUrl, display: 'block' },
                        _react2['default'].createElement(_blocks.Box, { is: 'img', className: '_footer__logo', src: isHf ? require('./hf_icon@2x.png') : require('./hs_icon@2x.png'), verticalAlign: 'middle' })
                    )
                ),
                _react2['default'].createElement(
                    _blocks.Flex,
                    { flexWrap: 'wrap', justifyContent: 'center', className: '_footer__links' },
                    _react2['default'].createElement(
                        _blocks.Box,
                        { p: 3, className: 'm-app-footer--links--link' },
                        _react2['default'].createElement(
                            _blocks.Box,
                            { is: 'a', href: pricingUrl, color: 'grey', hoverColor: 'ashen' },
                            'Pricing'
                        )
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { p: 3, className: 'm-app-footer--links--link product-link' },
                        _react2['default'].createElement(
                            _tetherToggle2['default'],
                            {
                                anchor: _react2['default'].createElement(
                                    _blocks.Box,
                                    { is: 'a', color: 'grey', hoverColor: 'ashen' },
                                    'Products'
                                ),
                                position: 'top',
                                justify: 'center'
                            },
                            items
                        )
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { p: 3, className: 'm-app-footer--links--link fine-print-link' },
                        _react2['default'].createElement(
                            _tetherToggle2['default'],
                            {
                                anchor: _react2['default'].createElement(
                                    _blocks.Box,
                                    { is: 'a', color: 'grey', hoverColor: 'ashen' },
                                    'Fine print'
                                ),
                                position: 'top',
                                justify: 'center'
                            },
                            finePrintItems
                        )
                    ),
                    _react2['default'].createElement(ZendeskActivator, null),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { p: 3, className: 'm-app-footer--links--link' },
                        _react2['default'].createElement(
                            _blocks.Box,
                            { is: 'a', href: faqUrl, target: '_blank', rel: 'noopener noreferrer', color: 'grey', hoverColor: 'a' },
                            'FAQ'
                        )
                    )
                )
            ),
            _react2['default'].createElement(
                _blocks.Flex,
                { justifyContent: 'center', className: '_footer__social m-app-footer--social' },
                social
            )
        );
    }
});

module.exports = AppFooter;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/footer/index.jsx
 ** module id = 836
 ** module chunks = 0 1
 **/